module.exports = __webpack_public_path__ + "img/Banner-principal-3.3c4fbdc2.webp";